import React from "react";
import { Link, LinkProps, useLocation, useResolvedPath } from "react-router-dom";

/**
 * Internal link. Every move between pages runs the route transition defined
 * in App.css; a hash link within the page the reader is already on just
 * scrolls there, since a crossfade over a scroll looks like a jump.
 */
const PageLink = ({ to, ...rest }: LinkProps) => {
  const { pathname } = useLocation();
  const target = useResolvedPath(to);
  const samePage = target.pathname === pathname && !!target.hash;
  return <Link to={to} viewTransition={!samePage} {...rest} />;
};

export default PageLink;
